import Player from '@vimeo/player';

/**
 * Toggle modal
 */
export function toggleModal() {
	const openTrigger = document.querySelector('.section-header .toggle-modal');
	const closeTrigger = document.querySelector('.modal .toggle-modal');
	const iframe = document.querySelector('.modal iframe');
	const backdrop = document.querySelector('.modal .modal__backdrop');
	const body = document.querySelector('body');

	if (openTrigger && closeTrigger && iframe) {
		const options = {
			byline: false,
			title: false,
			controls: false,
		};

		// Set iFrame source.
		iframe.src = openTrigger.getAttribute('data-src');

		// Create new player.
		const player = new Player(iframe, options);

		openTrigger.addEventListener('click', () => {
			// Open modal.
			body.classList.add('modal-open');

			// Start video.
			player.play();

			// Close modal by clicking on the backdrop.
			backdrop.addEventListener('click', () => {
				body.classList.remove('modal-open');

				player.pause();
			});
		});

		closeTrigger.addEventListener('click', () => {
			// Hide modal.
			body.classList.remove('modal-open');

			// Pause video.
			player.pause();
		});
	}
}

/**
 * Play modal video
 */
export function playModalVideo() {

}
